import { resolveStoreBadgeLocale } from './resolveStoreBadgeLocale'
import { appStoreBadges, googlePlayBadges, type BadgeContext } from './storeBadgeContexts'

const badges = {
  appStore: appStoreBadges,
  googlePlay: googlePlayBadges,
} as const

function localesIn(context: BadgeContext): Set<string> {
  return new Set(context.keys().map(key => key.replace(/^\.\//, '').replace(/\.svg$/, '')))
}

const localesByStore = {
  appStore: localesIn(appStoreBadges),
  googlePlay: localesIn(googlePlayBadges),
}

export type StoreBadge = keyof typeof badges

export function getStoreBadgeSrc(store: StoreBadge, locale: string | undefined): string {
  const resolved = resolveStoreBadgeLocale(locale, localesByStore[store])
  const badge = badges[store](`./${resolved}.svg`)
  return typeof badge === 'string' ? badge : badge.default
}
